<template>
  <div class="all">
    <div class="header">
      <h1>PROJECTS<br>作品專區</h1>
    </div>
    <section id="section1" class="section1">
      <div class="custom-container">
        <ul class="type-filter">
          <li class="type" :class="['ALL'===filterOption? 'is-checked' : '']" @click="filterCategories('ALL')">ALL&nbsp;&nbsp;/</li>
          <li class="type" v-for="item in categories" :key="item.category.id" :class="[item.category.trans.name===filterOption? 'is-checked' : '']" @click="filterCategories(item.category.trans.name)">{{item.category.trans.name}}&nbsp;&nbsp;/</li>
        </ul>
        <isotope ref="cpt" id="root_isotope1" class="row custom-row" :item-selector="'custom-grid'" :list="list" :options='option' @sort="sortOption=arguments[0]" @layout="currentLayout=arguments[0]">
          <div class="col-md-4 col-sm-6" v-for="element,index in list" :key="index">
            <router-link :to="{name: 'Projects-detail',params: { id: element.slug }}">
              <div class="project-card">
                <div class="project-img" :style="{'background-image': 'url(' + element.trans.icon_path + ')'}"></div>
                <div class="project-text"><span>{{formatDate(element.manufacture_date)}}_</span><span>{{element.trans.name}}_</span><span>{{element.trans.description}}</span></div>
              </div>
            </router-link>
          </div>
        </isotope>
        <transition name="zoom" mode="out-in">
          <div class="empty_msg" v-if="empty">此類別尚無作品。</div>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
  import navigation from './navigation.vue'
  import isotope from 'vueisotope'
  export default {
  name: 'Project',
    components:{
      navigation,
      isotope,
    },
    data() {
      return {
        empty:false,
        categories: [],
        list: [],
        date:[],
        filterOption: '',
        option: {
          itemSelector: ".custom-grid",
          getFilterData: {
            "ALL": function() {
              return true;
            },
            "category": function(el) {
              if (this.$parent) {
                return el.category.trans.name === this.$parent.filterOption;
              }
              return false;
            },
          },
        }
      }
    },
    methods:{
      filter: function(key) {
        this.$refs.cpt.filter(key);
        var filter_item = this.$refs.cpt.iso.filteredItems.length
        if(filter_item <= 0){
          this.empty = true;
        }else{
          this.empty = false;
        }
      },
      filterCategories(name) {
        this.filterOption = name;
        name === 'ALL' ? this.filter(name) : this.filter('category');
      },
      CallCategoryApi(){
        let vm = this;
        vm.axios({
          method: "get",
          url: process.env.VUE_API_URL + "v1/product-category",
        })
        .then(function (response) {
          let res = response.data.data;
          vm.categories = res;
          vm.filterCategories(vm.categories[0].category.trans.name);
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      CallProjectApi(){
        let vm = this;
        vm.axios({
          method: "get",
          url: process.env.VUE_API_URL + "v1/product",
        })
        .then(function (response) {
          let res = response.data.data;
          vm.list = res;
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      formatDate(date) {
        let formatted = new Date(date);
        let year = formatted.getFullYear().toString();
        let month = ("0" + (formatted.getMonth() + 1).toString()).slice(-2);
        return `${year}${month}`
      },
    },
    mounted(){
      this.CallProjectApi();
      this.CallCategoryApi();
    },
    watch:{

    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/project/header.scss';
  @import 'src/assets/scss/project/section1.scss';
</style>


// WEBPACK FOOTER //
// src/components/Projects.vue